export default __webpack_public_path__ + "media/sub_banner_en.535988c3.png";